module.exports = __webpack_public_path__ + "img/academy_calendar.8a0c0714.svg";